import { isly } from "isly";
import { DateSpan } from "../DateSpan";
export var TimeSpan;
(function (TimeSpan) {
    var _a;
    _a = DateSpan.type
        .extend({
        hours: isly.number().optional(),
        minutes: isly.number().optional(),
        seconds: isly.number().optional(),
        milliseconds: isly.number().optional(),
    }, "isoly.TimeSpan")
        .bind(), TimeSpan.type = _a.type, TimeSpan.is = _a.is, TimeSpan.flawed = _a.flawed;
    function toHours(value, round) {
        const result = (dateToMilliseconds(value) + (value.milliseconds ?? 0)) / (60 * 60 * 1000) +
            (value.seconds ?? 0) / (60 * 60) +
            (value.minutes ?? 0) / 60 +
            (value.hours ?? 0);
        return performRound(result, round);
    }
    TimeSpan.toHours = toHours;
    function toMinutes(value, round) {
        const result = (dateToMilliseconds(value) + (value.milliseconds ?? 0)) / (60 * 1000) +
            (value.seconds ?? 0) / 60 +
            (value.minutes ?? 0) +
            (value.hours ?? 0) * 60;
        return performRound(result, round);
    }
    TimeSpan.toMinutes = toMinutes;
    function toSeconds(value, round) {
        const result = (dateToMilliseconds(value) + (value.milliseconds ?? 0)) / 1000 +
            (value.seconds ?? 0) +
            (value.minutes ?? 0) * 60 +
            (value.hours ?? 0) * 60 * 60;
        return performRound(result, round);
    }
    TimeSpan.toSeconds = toSeconds;
    function toMilliseconds(value, round) {
        const result = dateToMilliseconds(value) +
            (value.milliseconds ?? 0) +
            (value.seconds ?? 0) * 1000 +
            (value.minutes ?? 0) * 60 * 1000 +
            (value.hours ?? 0) * 60 * 60 * 1000;
        return performRound(result, round);
    }
    TimeSpan.toMilliseconds = toMilliseconds;
    function unitByUnit(operation, left, ...rights) {
        return rights.reduce((result, span) => Object.entries(span).reduce((result, [key, right]) => (({ [key]: left, ...result }) => Object.assign(result, { [key]: +operation(left ?? 0, right ?? 0).toFixed(9) }))(result), result), left);
    }
    function add(...addends) {
        return normalize(unitByUnit((left, right) => left + right, {}, ...addends));
    }
    TimeSpan.add = add;
    function subtract(minuend, ...subtrahends) {
        return normalize(unitByUnit((left, right) => left - right, minuend, ...subtrahends));
    }
    TimeSpan.subtract = subtract;
    function fromHours(value, options) {
        let result;
        const precision = options?.precision ?? "milliseconds";
        const hours = Math.trunc(value);
        const remainder = +(value % 1).toFixed(9);
        if (precision != "hours") {
            result = { hours: hours, ...fromMinutes(remainder * 60, { precision, normalize: false }) };
        }
        else
            result = { hours: hours + Math.round(remainder) };
        return options?.normalize == false ? result : normalize(result);
    }
    TimeSpan.fromHours = fromHours;
    function fromMinutes(value, options) {
        let result;
        const precision = options?.precision ?? "milliseconds";
        const minutes = Math.trunc(value);
        const remainder = +(value % 1).toFixed(7);
        if (precision != "minutes")
            result = { minutes: minutes, ...fromSeconds(remainder * 60, { precision, normalize: false }) };
        else {
            const rounded = minutes + Math.round(remainder);
            result = add({ minutes: rounded % 60 }, fromHours(Math.trunc(rounded / 60), { precision: "hours", normalize: false }));
        }
        return options?.normalize == false ? result : normalize(result);
    }
    TimeSpan.fromMinutes = fromMinutes;
    function fromSeconds(value, options) {
        let result;
        const precision = options?.precision ?? "milliseconds";
        const seconds = Math.trunc(value);
        const remainder = +(value % 1).toFixed(5);
        if (precision != "seconds")
            result = { ...(seconds && { seconds: seconds }), ...fromMilliseconds(remainder * 1000, { normalize: false }) };
        else {
            const rounded = seconds + Math.round(remainder);
            result = add({ seconds: rounded % 60 }, fromMinutes(Math.trunc(rounded / 60), { precision: "minutes", normalize: false }));
        }
        return options?.normalize == false ? result : normalize(result);
    }
    TimeSpan.fromSeconds = fromSeconds;
    function fromMilliseconds(value, options) {
        const rounded = Math.round(value);
        const result = add(!rounded ? {} : { milliseconds: rounded % 1000 }, Math.abs(rounded) < 1000
            ? {}
            : fromSeconds(Math.trunc(rounded / 1000), { precision: "seconds", normalize: false }));
        return options?.normalize == false ? result : normalize(result);
    }
    TimeSpan.fromMilliseconds = fromMilliseconds;
    function normalize(value) {
        const result = {
            milliseconds: Math.round(toMilliseconds(value) % 1000),
            seconds: Math.trunc(toSeconds(value) % 60),
            minutes: Math.trunc(toMinutes(value) % 60),
            hours: Math.trunc(toHours(value)),
        };
        if (!(-1000 < result.milliseconds && result.milliseconds < 1000)) {
            result.seconds += Math.trunc(result.milliseconds / 1000);
            result.milliseconds = result.milliseconds % 1000;
        }
        if (!(-60 < result.seconds && result.seconds < 60)) {
            result.minutes += Math.trunc(result.seconds / 60);
            result.seconds = result.seconds % 60;
        }
        if (!(-60 < result.minutes && result.minutes < 60)) {
            result.hours += Math.trunc(result.minutes);
            result.minutes = result.minutes % 60;
        }
        return Object.fromEntries(Object.entries(result).filter(([, value]) => !!value));
    }
    TimeSpan.normalize = normalize;
})(TimeSpan || (TimeSpan = {}));
function dateToMilliseconds(span) {
    const now = Date.UTC(0, 0);
    const date = new Date(now);
    const future = Date.UTC(date.getUTCFullYear() + (span.years ?? 0), date.getUTCMonth() + (span.months ?? 0), date.getUTCDate() + (span.days ?? 0), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    return future.valueOf() - date.valueOf();
}
function performRound(value, round) {
    return !round
        ? value
        : round == "ceiling"
            ? Math.ceil(value)
            : round == "floor"
                ? Math.floor(value)
                : Math.round(value);
}
//# sourceMappingURL=index.js.map